import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateSecret = ({ onSecretCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    headline: "",
    items: [{ items: "" }] // Initialize as array of objects
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, value) => {
    const newItems = [...formData.items];
    newItems[index].items = value;
    setFormData(prev => ({
      ...prev,
      items: newItems
    }));
  };

  const addNewItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { items: "" }]
    }));
  };

  const removeItem = (index) => {
    const newItems = formData.items.filter((_, i) => i !== index);
    setFormData(prev => ({
      ...prev,
      items: newItems.length > 0 ? newItems : [{ items: "" }]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Filter out empty items
      const itemsToSubmit = formData.items.filter(item => item.items.trim() !== "");

      const dataToSend = {
        slug: formData.slug,
        headline: formData.headline,
        items: itemsToSubmit
      };

      const response = await axios.post(`${apiUrl}/secrets`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onSecretCreated) {
        onSecretCreated();
      }
      alert("Secret created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the secret.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Secret</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block mb-1">Headline:</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block mb-1">Secret Items:</label>
          {formData.items.map((item, index) => (
            <div key={index} className="flex mb-2">
              <input
                type="text"
                value={item.items}
                onChange={(e) => handleItemChange(index, e.target.value)}
                className="flex-1 p-2 border rounded"
                required
              />
              <button
                type="button"
                onClick={() => removeItem(index)}
                className="ml-2 px-3 bg-red-500 text-white rounded"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addNewItem}
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
          >
            Add Item
          </button>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create Secret"}
        </button>
      </form>
    </div>
  );
};

export default CreateSecret;